const bcBlue = '#003366';
const bcYellow = '#FCBA19';
const black = '#16161D';
const white = '#FFFFFF';
const RECORD_COLOURS = [
  white,
  '#2A81CB',
  '#FFD326',
  '#CB2B3E',
  '#2AAD27',
  '#CB8427',
  '#CAC428',
  '#9C2BCB',
  '#7B7B7B',
  '#3D3D3D'
];

export { bcBlue, bcYellow, black, white, RECORD_COLOURS };
